import { Component, OnDestroy, OnInit, TemplateRef, ViewChild, OnChanges, SimpleChanges, Input } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as alertifyjs from 'alertifyjs';
import Swal from 'sweetalert2';
import { DirectDebitService } from '../../services/direct-debit/direct-debit.service';
import { avisoInicioLote } from './aviso-inicio-lote.logica';
import { AuthService } from 'src/app/services/auth/auth.service';
import { UserService } from 'src/app/services/user/user.service';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';
import { saveAs } from 'file-saver';
import { SocketioService } from 'src/app/services/socket/socketio.service';

@Component({
  selector: 'app-dashboard-direc-debit',
  templateUrl: './dashboard-direc-debit.component.html',
  styleUrls: ['./dashboard-direc-debit.component.css'],
  providers: [DatePipe],
})
export class DashboardDirecDebitComponent implements OnInit, OnDestroy {
  @ViewChild('traceDocumentComponent') traceDocumentComponent: any;
  @ViewChild('progressMonitorComponent') progressMonitorComponent: any;
  
  startTraceDocument = true;
  startTraceDocumentDomiciliation = true;
  resumen: any;
  file: any;
  loading = true;
  sessionUser: any;
  profiles: any;
  profile: any;
  current_direct_debit: any;
  // Lotes activos para banco+tipo+flujo actuales. Para Diario (type=1) puede
  // haber lotes de días anteriores aún en proceso (UPLOADED, PROCESING, etc.)
  // y nada bloquea generar el lote del DÍA DE HOY si todavía no existe.
  activeLotes: any[] = [];
  // Si el usuario clickeó el placeholder "Generar lote de hoy" mientras existen
  // otros lotes activos de días anteriores.
  selectedLoteId: string | null = null;
  wantsTodayLote: boolean = false;
  status_sections: any = [];
  current_status_sections: any = [];
  loading_section: any = [];
  show_conciliacion_button = false;
  obj_conciliacion: any;
  provider: any = {
    tax_id_letter: 'J',
    tax_id: '311501878',
    tax_id_verification: '0',
  };

  // Carga configuración del producto y calcula bancos/tipos disponibles
  applyProductFilters = async () => {
    try {
      const productType = this.form.getRawValue().product || 'CREDIT';
      // leer config
      try {
        this.productConfig = await this.userService.getRemanenteNeteo(productType);
      } catch (e) {
        this.productConfig = null;
      }

      const allowedTypes: number[] = this.productConfig?.domiciliacion?.allowed_types || [];

      // bancos: se ofrecen todos los de la lista (con domiciliación activa). allowed_banks aplica
      // solo a altas nuevas; la cartera vieja (Provincial, Bancaribe) debe poder seguir corriendo lotes.
      this.availableBanks = [...this.banks];

      // tipos
      if (Array.isArray(allowedTypes) && allowedTypes.length > 0) {
        this.availableTypes = this.types.filter((t: any) => allowedTypes.includes(t.id));
      } else {
        this.availableTypes = [...this.types];
      }

      // Asegurar valores válidos en el formulario
      const curBank = this.form.get('bank')?.value;
      const curType = this.form.get('type')?.value;

      if (!this.availableBanks.find((b: any) => b.code === curBank)) {
        if (this.availableBanks.length > 0) {
          this.form.get('bank').setValue(this.availableBanks[0].code);
        } else {
          this.form.get('bank').setValue('');
        }
      }

      if (!this.availableTypes.find((t: any) => t.id === curType)) {
        if (this.availableTypes.length > 0) {
          this.form.get('type').setValue(this.availableTypes[0].id);
        } else {
          this.form.get('type').setValue('');
        }
      }
    } catch (error) {
      console.error('Error aplicando filtros de producto:', error);
      this.availableBanks = [...this.banks];
      this.availableTypes = [...this.types];
    }
  }
  template: string = '/lotes/bdv/send_final';
  sections: any = [
    {
      id: 1,
      name: 'Generar Domiciliación',
      status: 'INITIAL',
    },
    {
      id: 2,
      name: 'Descargar TXT',
      status: 'GENERATED',
    },
    {
      id: 3,
      name: 'Descargado',
      status: 'DOWNLOADED',
    },
    {
      id: 4,
      name: 'Domiciliación cargada al banco',
      status: 'UPLOADED',
    },
    {
      id: 5,
      name: 'Procesar Respuesta del banco',
      status: 'PROCESING',
    },
    {
      id: 6,
      name: 'Finalizado',
      status: 'FINISHED',
    },
  ];
  availableTypes: any = [];

  types: any = [
    {
      id: 1,
      name: 'Cuotas - Diario',
    },
    {
      id: 2,
      name: 'Cuotas - Masivo',
    },
    {
      id: 3,
      name: 'Cuotas - Morosos',
    },
    {
      id: 4,
      name: 'Penalidades',
    },
  ];

  // ===== Flujo Especial (ex-domiciliados) =====
  // Default 'standard' → comportamiento idéntico al actual.
  flujo: 'standard' | 'special' = 'standard';
  // Solo Masivo (2) y Penalidades (4) en flujo especial.
  readonly SPECIAL_FLOW_TYPE_IDS = [2, 4];
  get isSpecialFlow(): boolean { return this.flujo === 'special'; }
  get displayedTypes(): any[] {
    const base = (this.availableTypes?.length ? this.availableTypes : this.types) || [];
    if (this.isSpecialFlow) {
      return base.filter((t: any) => this.SPECIAL_FLOW_TYPE_IDS.includes(Number(t?.id)));
    }
    return base;
  }
  onFlujoChange(): void {
    // Si se pasa a Especial y el tipo actual no está permitido, resetear el campo type.
    if (this.isSpecialFlow) {
      const t = Number(this.form?.getRawValue?.()?.type);
      if (!this.SPECIAL_FLOW_TYPE_IDS.includes(t)) {
        try { this.form?.patchValue?.({ type: '' }); } catch (_) {}
      }
    }
    // Refrescar el lote activo según el flujo seleccionado — los lotes estándar y
    // especial conviven en BD pero pertenecen a flujos distintos, no deben mezclarse.
    try {
      const bank = this.form?.getRawValue?.()?.bank;
      const type = this.form?.getRawValue?.()?.type;
      if (bank && type) {
        this.updateCurrentDirectDebit();
      } else {
        // Si no hay selección completa, limpiar la card del lote activo.
        this.current_direct_debit = null;
      }
    } catch (_) { /* no-op */ }
  }

  banks: any = [];
  availableBanks: any = [];
  products: any = []; // Productos con domiciliación activa
  
  // Propiedades para búsqueda de productos
  productSearchTerm: string = '';
  filteredProducts: any[] = [];
  showProductDropdown: boolean = false;

  // Información de la tasa del producto
  productRateInfo: any = null;
  loadingRateInfo: boolean = false;
  rateInfoError: boolean = false;
  rateInfoErrorMessage: string = '';

  pending: any;

  view = 1;
  form: FormGroup | any = this.formBuilder.group({
    product: [''],
    bank: [''],
    type: [''],
  });
  files: any = [];

  date: any = new Date();
  current_date: any = this.datePipe.transform(new Date(), 'yyyy-MM-dd');

  btn_restart = false;
  btn_restart_conciliation = false;
  response_trace_conciliation: any;

  config: any; 
  config_read: any;
  productConfig: any;

  bank: any;

  changesDirectDebitSubscription: any;

  // Variables para controlar el botón de reiniciar proceso
  show_reset_trace_button = false;
  lastProgressPercentage: number | null = null;
  lastProgressChangeTime: number | null = null;
  progressCheckInterval: any = null;

  // 🧪 Variables para modo test
  testMode: boolean = false;
  testPreset: string = 'realistic';
  testConfig: any = {
    success_rate: 70,
    partial_rate: 20,
    error_rate: 10,
    partial_amount_percent: 50,
    error_codes: ['FONDOS_INSUFICIENTES', 'CUENTA_BLOQUEADA', 'CUENTA_CERRADA']
  };
  wasTestMode: boolean = false;
  isProduction: boolean = environment.production; // Ocultar modo test en producción



  constructor(
    private userService: UserService,
    private offcanvasService: NgbOffcanvas,
    private formBuilder: FormBuilder,
    private directDebitService: DirectDebitService,
    public _auth: AuthService,
    private datePipe: DatePipe,
    public socketService: SocketioService
  ) {}

  async ngOnInit() {
    this.sessionUser = this._auth.sessionUser;
    this.profiles = this._auth.getProfiles();
    this.profile = this.getProfile(this.sessionUser);
    this.banks = await this.getBanks();
    this.banks = this.banks.res;
    
    // Cargar productos con domiciliación activa
    await this.loadProductsWithDomiciliation();

    // Aplicar filtros por producto (bancos y tipos)
    await this.applyProductFilters();
    
    this.setDefault();
    this.updateCurrentDirectDebit();
    this.config = await this.getDirectDebitConfig('template');
    this.config_read = await this.getDirectDebitConfig('read');

    // sockets
    this.changesDirectDebitSubscription = this.socketService.changesDirectDebit.subscribe((resp: any) => {
      if(resp){
        console.log('Direct Debit: Cambió');
        console.log(resp.trace);
        if(resp.trace === this.current_direct_debit?.trace) {
          console.log('refrescaré');
          this.updateCurrentDirectDebit();
        }
      }
    });


  }

  getDirectDebitConfig = (type: string): Promise<any> => {
    let bank = this.form.getRawValue().bank;
    return this.directDebitService.getDirectDebitConfig(bank, type, 'DOMICILIATION');
  };

  getCurrentDate = async () => {
    const productType = this.form.getRawValue().product || 'CREDIT';
    this.pending = await this.directDebitService.pendingLote(productType);
    if (this.pending.resp.length > 0) {
      this.date = this.datePipe.transform(
        this.pending.resp[0].date,
        'yyyy-MM-dd'
      );
    } else {
      this.date = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    }
  };

  getProfile(user: any) {
    let profiles = user?.profile;
    let profile;
    if (profiles) {
      let value = this.profiles[profiles[0]];
      let key = profiles[0];
      profile = { key, value };
    }
    return profile;
  }

  updateStatusSections = async () => {
    await this.getStatusCurrentDirectDebit();
    let iter_section;
    this.sections.map((section: any) => {
      this.status_sections[section.status] = 'PENDING';
      iter_section = this.validateSection(section.status);
      if (iter_section) {
        this.status_sections[section.status] = iter_section;
      }
    });
    this.config = await this.getDirectDebitConfig('template');
    this.config_read = await this.getDirectDebitConfig('read');
    this.loading = false;
  };

  validateSection = (status: string) => {
    return this.current_status_sections.find((section: any) => {
      return section.status === status;
    });
  };



  // updateCurrentDirectDebit = async (direct_debit: any) => {
  //   this.getCurrentDate();
  //   //this.current_direct_debit = null;
  //   this.files = [];
  //   if(direct_debit) {
  //     this.current_direct_debit = direct_debit;

  //   } else {
  //     this.current_direct_debit = null;
  //   }
  //   this.updateStatusSections();
  // };

  updateCurrentDirectDebit = async () => {
    this.getCurrentDate();
    //this.current_direct_debit = null;


    this.files = [];
    const productType = this.form.getRawValue().product || 'CREDIT';
    // El flujo (estándar vs especial) separa los lotes activos: pasamos el flag para
    // que el backend devuelva solo los del flujo actualmente seleccionado.
    const resp: any = await this.getDebitDirectByBankAndType(
      this.form.getRawValue().bank,
      this.form.getRawValue().type,
      this.date,
      productType,
      this.isSpecialFlow
    );
    this.btn_restart = false;
    const lotes: any[] = (resp && Array.isArray(resp.res)) ? resp.res : [];
    // Ordeno por fecha asc: el más reciente queda último.
    lotes.sort((a: any, b: any) => new Date(a.date).getTime() - new Date(b.date).getTime());
    this.activeLotes = lotes;

    const previousLoteId = this.selectedLoteId;

    if (lotes.length === 0) {
      if (previousLoteId) this.resetProcessState();
      this.current_direct_debit = null;
      this.selectedLoteId = null;
      this.wantsTodayLote = false;
      this.bank = null;
    } else {
      // Mantengo la selección previa si sigue vigente; sino tomo el más reciente.
      const stillThere = this.selectedLoteId && lotes.find(l => l._id === this.selectedLoteId);
      const pick = stillThere || lotes[lotes.length - 1];
      // Si el lote mostrado pasa a ser OTRO (cambio de banco/tipo/producto, o el anterior ya no
      // está activo), el estado del wizard es del lote viejo y hay que limpiarlo.
      if (previousLoteId && previousLoteId !== pick._id) {
        this.resetProcessState();
      }
      this.selectedLoteId = pick._id;
      this.current_direct_debit = pick;
      this.wantsTodayLote = false;
      this.getCurrentBank(this.current_direct_debit.bank);
    }
    this.updateStatusSections();
    this.startTraceDocument =false;
    setTimeout(()=> { this.startTraceDocument = true }, 5);

    this.startTraceDocumentDomiciliation =false;
    setTimeout(()=> { this.startTraceDocumentDomiciliation = true }, 5);

  }

  // ===== Selector multi-lote (solo Diario type=1) =====

  isSameCalendarDay(dateA: any, dateB: any): boolean {
    if (!dateA || !dateB) return false;
    const a = new Date(dateA), b = new Date(dateB);
    return a.getFullYear() === b.getFullYear()
        && a.getMonth() === b.getMonth()
        && a.getDate() === b.getDate();
  }

  getTodayDate(): Date {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
  }

  // ¿type=1 y aún no existe un lote del día de hoy?
  // Ofrecemos crearlo aunque haya otros lotes activos de días previos.
  canOfferTodayLote(): boolean {
    if (Number(this.form?.getRawValue()?.type) !== 1) return false;
    if (this.isSpecialFlow) return false;
    const today = this.getTodayDate();
    const hasToday = this.activeLotes.some(l => this.isSameCalendarDay(l.date, today));
    return !hasToday;
  }

  // Estado que pertenece AL LOTE que se está viendo. Si no se limpia al cambiar de lote, el
  // wizard sigue mostrando el avance del anterior (parece terminado sin estarlo) y —peor— deja
  // cargado el archivo del lote anterior listo para conciliarse contra el lote nuevo.
  resetProcessState = () => {
    this.resumen = null;
    this.file = null;
    this.files = [];
    this.obj_conciliacion = null;
    this.show_conciliacion_button = false;
    this.response_trace_conciliation = null;
    this.btn_restart = false;
    this.btn_restart_conciliation = false;
    this.show_reset_trace_button = false;
    this.lastProgressPercentage = null;
    this.lastProgressChangeTime = null;
    this.loading_section = [];
    // El watchdog de "progreso estancado" quedaría contando contra el lote anterior.
    if (this.progressCheckInterval) {
      clearInterval(this.progressCheckInterval);
      this.progressCheckInterval = null;
    }
  };

  selectLote(loteId: string) {
    const lote = this.activeLotes.find(l => l._id === loteId);
    if (!lote) return;
    if (loteId !== this.selectedLoteId) {
      this.resetProcessState();
    }
    this.selectedLoteId = loteId;
    this.current_direct_debit = lote;
    this.wantsTodayLote = false;
    this.getCurrentBank(lote.bank);
    this.updateStatusSections();
    // Forzar refresh de los trace monitors apuntando al lote elegido.
    this.startTraceDocument = false;
    setTimeout(()=> { this.startTraceDocument = true }, 5);
    this.startTraceDocumentDomiciliation = false;
    setTimeout(()=> { this.startTraceDocumentDomiciliation = true }, 5);
  }

  selectTodayPlaceholder() {
    // No hay un lote real todavía; preparamos el botón "Iniciar" para generar
    // el lote de HOY (sin target_date — el backend default es hoy).
    this.resetProcessState();
    this.selectedLoteId = null;
    this.current_direct_debit = null;
    this.wantsTodayLote = true;
    this.updateStatusSections();
  }

  getCurrentBank = (bank: any) => {
    this.bank = this.banks.find((ele: any)=> bank===ele._id);
  }

  setResponse = (elements: any[], type: string) => {
    if(elements.length>0) {
      if(elements[0].state==="ERROR" && type==="START") {
        this.btn_restart = true;
      }else if(elements[0].state==="ERROR" && type==="CONCILIATION") {
        this.btn_restart_conciliation = true;
        this.response_trace_conciliation = elements;
      } else if(type==="CONCILIATION") {
        this.response_trace_conciliation = elements;
        
        // Refrescar el monitor de progreso cuando se actualiza el trace
        if (this.progressMonitorComponent) {
          this.progressMonitorComponent.refresh();
        }
        
        // Monitorear el progreso para mostrar el botón de reiniciar
        if (elements[0].percentage !== undefined) {
          this.checkProgressForResetButton(elements[0].percentage);
        }
      }
    }
  }

  // Verifica si el progreso ha cambiado y controla cuándo mostrar el botón de reiniciar
  checkProgressForResetButton = (currentPercentage: number) => {
    const now = Date.now();
    
    // Si el porcentaje cambió, actualizar el tiempo
    if (this.lastProgressPercentage !== currentPercentage) {
      this.lastProgressPercentage = currentPercentage;
      this.lastProgressChangeTime = now;
      this.show_reset_trace_button = false;
      
      // Limpiar intervalo anterior si existe
      if (this.progressCheckInterval) {
        clearInterval(this.progressCheckInterval);
        this.progressCheckInterval = null;
      }
      
      // Iniciar nuevo intervalo para verificar si han pasado 20 segundos
      this.progressCheckInterval = setInterval(() => {
        this.checkIfProgressStuck();
      }, 1000); // Verificar cada segundo
    }
  }

  // Verifica si han pasado 20 segundos sin cambios en el progreso
  checkIfProgressStuck = () => {
    if (!this.lastProgressChangeTime) return;
    
    const now = Date.now();
    const secondsSinceLastChange = (now - this.lastProgressChangeTime) / 1000;
    
    // Si han pasado 20 segundos y el status es UPLOADED, mostrar el botón
    if (secondsSinceLastChange >= 20 && this.status_sections['UPLOADED'] !== 'PENDING') {
      this.show_reset_trace_button = true;
      
      // Limpiar el intervalo ya que ya mostramos el botón
      if (this.progressCheckInterval) {
        clearInterval(this.progressCheckInterval);
        this.progressCheckInterval = null;
      }
    }
  }


  getStatusCurrentDirectDebit = async () => {
    if (this.current_direct_debit) {
      this.current_status_sections = await this.getDebitDirectStatuses(
        this.current_direct_debit._id
      );
      this.current_status_sections = this.current_status_sections.res;
    } else {
      this.current_status_sections = [];
    }
  };

  setDefault = () => {
    const banksSource = this.availableBanks?.length ? this.availableBanks : this.banks;
    if (banksSource.length >= 1) {
      this.form.get('bank').setValue(banksSource[0].code);
      this.form.get('bank').patchValue(banksSource[0].code);
    }
    const typesSource = this.availableTypes?.length ? this.availableTypes : this.types;
    if (typesSource.length >= 1) {
      this.form.get('type').setValue(typesSource[0].id);
      this.form.get('type').patchValue(typesSource[0].id);
    }
  };

  getDebitDirectByBankAndType = (
    bank: string,
    type: string,
    date: any,
    productType?: string,
    specialFlow?: boolean
  ): Promise<any> => {
    return this.directDebitService.getDirectDebit(bank, type, date, productType, specialFlow);
  };

  getDebitDirectStatuses = (direct_debit_id: string): Promise<any> => {
    return this.directDebitService.getDirectDebitStatuses(direct_debit_id);
  };

  getBanks = async () => {
    return await this.userService.getBanksWithDirectDebitEnabled({});
  };

  loadProductsWithDomiciliation = async () => {
    try {
      const response = await this.userService.getActiveProductsInvoices(true);
      if (response && response.resp) {
        this.products = response.resp;
        console.log('Productos con domiciliación activa:', this.products);
        
        // Buscar CREDIT en los productos
        const creditProduct = this.products.find((p: any) => p?.params?.code === 'CREDIT');
        
        if (creditProduct) {
          // Si existe CREDIT, seleccionarlo por defecto
          this.form.patchValue({
            product: 'CREDIT'
          });
          this.productSearchTerm = 'CREDIT'; // Mostrar el código en el input
          this.loadProductRateInfo('CREDIT'); // Cargar info de tasa
        } else if (this.products.length > 0) {
          // Si no existe CREDIT, seleccionar el primer producto
          const firstProduct = this.products[0];
          this.form.patchValue({
            product: firstProduct?.params?.code
          });
          this.productSearchTerm = firstProduct?.params?.code; // Mostrar el código
          this.loadProductRateInfo(firstProduct?.params?.code); // Cargar info de tasa
        }
      } else {
        this.products = [];
      }
    } catch (error) {
      console.error('Error al cargar productos con domiciliación:', error);
      alertifyjs.error('Error al cargar productos con domiciliación');
      this.products = [];
    }
  };

  openModalBanks = (content: TemplateRef<any>, data: any = {}) => {
    try {
      this.offcanvasService.open(content, {
        position: 'bottom',
        keyboard: false,
      });
    } catch (error) {
      console.log(error);
    }
  };

  pendingDirectDebit = async () => {
    const productType = this.form.getRawValue().product || 'CREDIT';
    return await this.directDebitService.pendingLote(productType);
  };

  testPending  = async () => {
    let body = {
      type: this.form.getRawValue().type,
      bankCode: this.form.getRawValue().bank,
      user: this.sessionUser.uid,
      template: this.template,
      provider: this.provider,
    };

    let response = await this.directDebitService.pendingDirectDebit(
      body
    );
    console.log(response);
  }

  /**
   * Alerta con el/los lote(s) sin finalizar antes de generar uno nuevo.
   * NUNCA genera un lote desde aquí (forzar es peligroso → cobro duplicado).
   * Si hay un lote marcado COMPLETADO sin conciliar, ofrece "Recuperar lote":
   * le quita el completed (lo pone activo de nuevo) para que se concilie normalmente.
   * Siempre devuelve false (la generación no continúa).
   */
  confirmActiveLotesAlert = async (lotes: any[]): Promise<boolean> => {
    const fmt = (d: any) => { try { return d ? new Date(d).toLocaleString('es-VE') : '—'; } catch { return '—'; } };
    const money = (n: any) => (n === null || n === undefined) ? '—' : Number(n).toLocaleString('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    const recoverable = (lotes || []).find((l: any) => l.completed_sin_conciliar);

    const cards = (lotes || []).map((l: any) => `
      <div style="text-align:left;border:1px solid #fca5a5;background:#fef2f2;border-radius:8px;padding:10px;margin-bottom:8px;font-size:12px;line-height:1.5">
        <div><b>Lote:</b> ${l.lote || '—'}
          ${l.completed_sin_conciliar ? '<span style="color:#b91c1c;font-weight:700;margin-left:6px">⚠ marcado COMPLETADO sin conciliar</span>' : ''}
        </div>
        <div><b>Status:</b> ${l.status || '—'} &nbsp;·&nbsp; <b>Completado:</b> ${l.completed ? 'Sí' : 'No'}</div>
        <div><b>Registrado por:</b> ${l.registrado_por || l.username || '—'}</div>
        <div><b>Fecha:</b> ${fmt(l.date)} &nbsp;·&nbsp; <b>Últ. actualización:</b> ${fmt(l.last_update)}</div>
        <div><b>Monto:</b> ${money(l.total_amount)} &nbsp;·&nbsp; <b>Tipo:</b> ${l.type || '—'} &nbsp;·&nbsp; <b>Producto:</b> ${l.product_type || '—'}</div>
        <div style="color:#6b7280"><b>Trace:</b> ${l.trace || '—'}</div>
      </div>`).join('');

    const result = await Swal.fire({
      icon: 'warning',
      title: 'Ya existe un lote sin finalizar',
      html: `<p style="font-size:13px;text-align:left">
               Se encontró <b>${lotes.length}</b> lote(s) de este banco/tipo que <b>aún no han sido conciliados</b>.
               No se generará un lote nuevo para evitar un <b>cobro duplicado</b>.
             </p>${cards}
             ${recoverable
        ? `<p style="font-size:12px;text-align:left;color:#b91c1c">El lote <b>${recoverable.lote}</b> quedó marcado como completado <b>sin haberse conciliado</b>. Puedes <b>recuperarlo</b>: vuelve a quedar activo (completed=false) para completar su conciliación. <b>No</b> se genera un lote nuevo.</p>`
        : ''}`,
      width: 660,
      showCancelButton: true,
      cancelButtonText: 'Cerrar',
      showConfirmButton: !!recoverable,
      confirmButtonText: recoverable ? `Recuperar lote ${recoverable.lote}` : '',
      confirmButtonColor: '#16a34a',
      reverseButtons: true
    });

    if (recoverable && result.isConfirmed) {
      try {
        const resp = await this.directDebitService.recoverLote({ id: recoverable.id });
        if (resp?.success) {
          await Swal.fire('Lote recuperado', resp?.description || `El lote ${recoverable.lote} volvió a estado activo. Concílielo para finalizarlo.`, 'success');
          await this.updateCurrentDirectDebit();
        } else {
          await Swal.fire('No se pudo recuperar', resp?.description || 'Intenta de nuevo.', 'error');
        }
      } catch (e) {
        await Swal.fire('Error', 'No se pudo recuperar el lote.', 'error');
      }
    }

    // Nunca se genera un lote nuevo desde esta alerta.
    return false;
  };

  startDirectDebit = async () => {
      this.loading_section['INITIAL'] = true;
      const baseBody: any = {
        type: this.form.getRawValue().type,
        bankCode: this.form.getRawValue().bank,
        product_type: this.form.getRawValue().product || 'CREDIT',
        user: this.sessionUser.uid,
        template: this.config.template,
        provider: this.provider,
        config: this.config ?? null,
      };

      // Para Diario (type=1) con placeholder "Generar lote de hoy", el body se
      // envía sin target_date; el backend usa por default el día de hoy. La
      // unicidad la garantiza getActiveLoteBanks con targetDate=hoy en el server.

      // 🛡️ BLINDAJE anti-duplicado: avisar si ya existe un lote del mismo banco/tipo/día
      // que aún NO está finalizado (status no terminal, sin importar completed). Evita
      // generar un lote repetido y mandar a cobro dos veces (incidente del 10/06).
      if (!this.isSpecialFlow) {
        try {
          const pre = await this.directDebitService.precheckActiveLotes({
            bankCode: baseBody.bankCode,
            type: baseBody.type,
            product_type: baseBody.product_type
          });
          if (pre?.success && pre.count > 0) {
            // La alerta nunca genera un lote (forzar es peligroso). Si corresponde,
            // permite "recuperar" el lote mal completado. Siempre detenemos la generación.
            await this.confirmActiveLotesAlert(pre.lotes);
            delete this.loading_section['INITIAL'];
            return;
          }
        } catch (e) {
          // Si el pre-check falla, NO bloqueamos la generación: el guard del servidor
          // (getActiveLoteBanks endurecido) sigue protegiendo contra duplicados.
          console.warn('[DD] precheckActiveLotes falló, continúa con el guard del server:', e);
        }
      }

      // Si flujo especial, validar tipo permitido y agregar cutoff_days.
      let response: any;
      try {
        if (this.isSpecialFlow) {
          const tipoNum = Number(baseBody.type);
          if (!this.SPECIAL_FLOW_TYPE_IDS.includes(tipoNum)) {
            alertifyjs.error('Flujo Especial: solo se admite Cuotas - Masivo o Penalidades.');
            delete this.loading_section['INITIAL'];
            return;
          }
          // Por requerimiento: el flujo especial siempre opera sin ventana (todos los ex-domiciliados).
          response = await this.directDebitService.startDirectDebitSpecialProcess({ ...baseBody, cutoff_days: null });
        } else {
          // Flujo estándar — comportamiento idéntico al actual.
          response = await this.directDebitService.startDirectDebitProcess(baseBody);
        }

        if (response.success) {
          //if (response.data) {
            await this.updateCurrentDirectDebit();
            delete this.loading_section['INITIAL'];
          // } else {
          //   alertifyjs.error(
          //     'No hay pagos pendientes que cumplan con los críterios seleccionados'
          //   );
          //   delete this.loading_section['INITIAL'];
          // }
        } else {
          delete this.loading_section['INITIAL'];
          this.mostrarAvisoInicioLote(response);
        }
      } catch(error) {
          console.log(error);
          delete this.loading_section['INITIAL'];
          this.mostrarAvisoInicioLote(error);
      }
    
  };

  // El núcleo rechaza el lote con 400 + description/msg (p. ej. banco sin contrato CT): se explica, no se pinta de error.
  private mostrarAvisoInicioLote = (error: any) => {
    const aviso = avisoInicioLote(error);
    if (aviso.tipo === 'aviso') {
      Swal.fire({ icon: 'info', title: 'No se generó el lote', text: aviso.mensaje, confirmButtonText: 'Entendido' });
    } else {
      alertifyjs.error(aviso.mensaje);
    }
  };

  downloadCheck = async () => {
    if(this.status_sections['FINISHED']==='PENDING' && this.status_sections['PROCESING']==='PENDING' && this.status_sections['UPLOADED']==='PENDING'){
      let body = {
        direct_debit_id: this.current_direct_debit._id,
        status: 'DOWNLOADED',
        user: this.sessionUser.uid,
      };
      console.log(body);
      await this.directDebitService.saveDirectDebitStatus(body);
      await this.updateCurrentDirectDebit();
    }
  };

  offcanvasServiceClose() {
    this.view = 1;
    this.offcanvasService.dismiss();
  }

  reset = (evt: any) => {
    this.show_conciliacion_button = false;
    this.obj_conciliacion = null;
  };

  getResponse = (response: any) => {
    console.log(response);
    if (response) {
      this.resumen = response;
      this.show_conciliacion_button = true;
      this.obj_conciliacion = response.response;
      this.file = response.file;
    } else {
      this.resumen = null;
      this.show_conciliacion_button = false;
      this.obj_conciliacion = null;
      this.file = null;
    }
  };

  conciliar = async () => {
    let redflags = this.resumen?.resumen?.redflags.length > 0 ? true : false;
    if(redflags) {
      Swal.fire({
        title: 'Importante',
        text: 'Por favor, revise detalladamente la respuesta del banco. Se han encontrado elementos que pueden generar problemas en la conciliación. ¿Ya lo ha revisado? ¿Desea continuar?',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        showCancelButton: true,
        confirmButtonText: `Si!`,
        cancelButtonText: `Cancelar!`,
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.ejecutarConciliacion();
        }
      });
    } else {
      this.ejecutarConciliacion();
    }


    
    
  };

  ejecutarConciliacion = async () => {
    if (this.current_direct_debit && !this.loading_section['PROCESING']) {
        // este el el loading del botón
      this.loading_section['PROCESING'] = true;

      // lectura del header de la respuesta
      let header = this.getHeader(this.obj_conciliacion.data, this.bank.acron);

      // objeto requerido por el servicio de conciliación
      let fechavalor;
      let fvalor = header[0]['FVALOR'] ?? "";
      if(fvalor.includes('/')) {
        fechavalor = header[0]['FVALOR']?header[0]['FVALOR'].split('/').reverse().join('/'): this.current_direct_debit.date.split('T')[0]
      } else { 
        if(fvalor!=="") {
          const year = header[0]['FVALOR'].slice(0, 4);
          const month = header[0]['FVALOR'].slice(4, 6);
          const day = header[0]['FVALOR'].slice(6, 8);
          fechavalor = `${year}/${month}/${day}`;
        }
      }
      debugger;
      let obj = {
        bank_acron: this.bank.acron,
        config: this.config_read.config,
        bank: this.current_direct_debit.bank,
        tax_id: this.provider.tax_id_letter + this.provider.tax_id,
        id_direct_debit: this.current_direct_debit._id,
        token: localStorage.getItem('x-token'),
        date: header[0]['FVALOR']?fechavalor: this.current_direct_debit.date.split('T')[0],
        rate: this.current_direct_debit.rate?this.current_direct_debit.rate: undefined,
        user: this.sessionUser.uid,
        url: this.obj_conciliacion.file.url,
        codigo: header[0]['CODNEGO']?header[0]['CODNEGO']:header[0]['LOTE'],
        trace: this.current_direct_debit.trace
      };
      try {
          // try{


          //   // este es el único servicio encargado de la conciliación Juan
          let response = await this.directDebitService.conciliar(JSON.stringify(obj), this.file);

            if(response) {
              if(!response.success) {
                alertifyjs.warning(
                  response.description
                );
                // El lote NO se concilió: hay que dejar el botón disponible para reintentar
                // (ej: se bloqueó por precondiciones, se corre el backfill y se reintenta).
                this.show_conciliacion_button = true;
                this.loading_section['PROCESING'] = false;
                return;
              } else {
                // 📊 El monitor se activará automáticamente cuando app-direct-debit-trace-document
                // detecte el trace y llame a setResponse()
                console.log('✅ Conciliación iniciada, el monitor se activará automáticamente');
              }
            }
            
            // estos servicios se utilizan para actualizar los estatus de las vistas, segun la tabla de direct debit statuses
            await this.updateCurrentDirectDebit();

            // se desmarca el proceso de conciliación activo
            this.show_conciliacion_button = false;
            this.loading_section['PROCESING'] = false;
            

          // } catch(e) {
          //   alertifyjs.error(
          //     'Ha ocurrido un error en el proceso de conciliación, contacte con el administrador o reintente conciliar.' + e
          //   );
          //   this.show_conciliacion_button = true;
          //   this.loading_section['PROCESING'] = false;
          // }
        } catch (error) {
          console.log(error);
          this.show_conciliacion_button = true;
          this.loading_section['PROCESING'] = false;
          alertifyjs.error(
            'Ha ocurrido un error en el proceso de conciliación, contacte con el administrador o reintente conciliar.' + error
          );
        }
    }
  }

  /**
   * 📊 Callback cuando se completa la conciliación
   */
  onConciliationComplete = async () => {
    console.log('✅ Conciliación completada desde el monitor');
    
    // Recargar datos
    await this.updateCurrentDirectDebit();
    
    // Mostrar mensaje de éxito
    alertifyjs.success('Conciliación completada exitosamente');
  }

  // 🧪 MÉTODOS PARA MODO TEST

  /**
   * Cambiar modo test/real
   */
  onTestModeChange = () => {
    if (this.testMode) {
      Swal.fire({
        title: '⚠️ Modo Test',
        html: `
          <p>Está activando el <strong>modo de prueba</strong>.</p>
          <p>Se generarán datos simulados para testing.</p>
          <p class="text-danger"><strong>⚠️ Este modo NO debe usarse en producción</strong></p>
        `,
        icon: 'warning',
        confirmButtonText: 'Entendido'
      });
    }
    
    // Limpiar archivo si cambia a test
    if (this.testMode) {
      this.file = null;
      this.show_conciliacion_button = false;
    }
  }

  /**
   * Aplicar preset de configuración
   */
  applyTestPreset = () => {
    const presets: any = {
      all_success: { success_rate: 100, partial_rate: 0, error_rate: 0 },
      realistic: { success_rate: 70, partial_rate: 20, error_rate: 10 },
      mixed_50: { success_rate: 50, partial_rate: 0, error_rate: 50 },
      all_errors: { success_rate: 0, partial_rate: 0, error_rate: 100 },
      custom: this.testConfig
    };
    
    if (this.testPreset !== 'custom') {
      this.testConfig = { ...this.testConfig, ...presets[this.testPreset] };
    }
  }

  /**
   * Validar configuración de test
   */
  isTestConfigValid = (): boolean => {
    const total = this.testConfig.success_rate + this.testConfig.partial_rate + this.testConfig.error_rate;
    return total === 100;
  }

  /**
   * Obtener nombre del preset
   */
  getPresetName = (): string => {
    const names: any = {
      all_success: 'Todo Exitoso',
      realistic: 'Realista (70/20/10)',
      mixed_50: 'Mixto 50/50',
      all_errors: 'Todo Rechazado',
      custom: 'Personalizado'
    };
    return names[this.testPreset] || 'Personalizado';
  }

  /**
   * Ejecutar conciliación en modo test
   */
  conciliarTest = async () => {
    // Validación de porcentajes
    if (!this.isTestConfigValid()) {
      alertifyjs.error('La suma de porcentajes debe ser 100%');
      return;
    }
    
    // Confirmación SweetAlert
    const result = await Swal.fire({
      title: '🧪 Confirmar Conciliación de Prueba',
      html: `
        <div class="text-start">
          <p><strong>Escenario:</strong> ${this.getPresetName()}</p>
          <p><strong>Configuración:</strong></p>
          <ul>
            <li>✅ Exitosos: ${this.testConfig.success_rate}%</li>
            <li>⚠️ Parciales: ${this.testConfig.partial_rate}%</li>
            <li>❌ Rechazados: ${this.testConfig.error_rate}%</li>
          </ul>
          <p class="text-warning mt-3">
            <i class="fas fa-exclamation-triangle me-2"></i>
            <strong>Esta es una simulación con datos generados</strong>
          </p>
        </div>
      `,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#ffc107',
      cancelButtonColor: '#6c757d',
      confirmButtonText: '<i class="fas fa-flask me-2"></i>Sí, ejecutar prueba',
      cancelButtonText: 'Cancelar'
    });
    
    if (!result.isConfirmed) return;
    
    this.loading_section['PROCESING'] = true;
    this.wasTestMode = true;
    
    // Objeto con flag de test_mode
    let obj = {
      bank_acron: this.bank.acron,
      config: this.config_read.config,
      bank: this.current_direct_debit.bank,
      tax_id: this.provider.tax_id_letter + this.provider.tax_id,
      id_direct_debit: this.current_direct_debit._id,
      token: localStorage.getItem('x-token'),
      date: this.current_direct_debit.date.split('T')[0],
      rate: this.current_direct_debit.rate,
      user: this.sessionUser.uid,
      trace: this.current_direct_debit.trace,
      
      // 🧪 FLAGS DE MODO TEST
      test_mode: true,
      test_config: {
        success_rate: this.testConfig.success_rate,
        partial_rate: this.testConfig.partial_rate,
        error_rate: this.testConfig.error_rate,
        partial_amount_percent: this.testConfig.partial_amount_percent,
        error_codes: this.testConfig.error_codes,
        bank_acron: this.bank.acron
      }
    };
    
    try {
      // Llamar al servicio SIN archivo (null)
      let response = await this.directDebitService.conciliar(JSON.stringify(obj), null);
      
      if (response?.success) {
        alertifyjs.success('🧪 Conciliación de prueba iniciada');
      } else {
        alertifyjs.error(response?.description || 'Error al iniciar conciliación de prueba');
      }
      
      await this.updateCurrentDirectDebit();
      this.loading_section['PROCESING'] = false;
      
    } catch (error) {
      console.error(error);
      alertifyjs.error('Error en conciliación de prueba: ' + error);
      this.loading_section['PROCESING'] = false;
    }
  }

 
  formatDataToExcel = (obj: any) => {
    let response: any = [];

    obj.map((element: any) => {
      console.log(element);
      response = [
        ...response,
        {
          CEDULA: element.identity,
          CREDITO: element.num_credit,
          REFERENCIA: element.reference,
          'NUMERO DE CUENTA': element.num_cuenta,
          'PROCESADO POR EL BANCO': element.success ? 'SI' : 'NO',
          DESCRIPCION: element.description,
          CONCILIADO: element?.conciliation?.reconciled_payment ? 'SI' : 'NO',
          MONTO: element.conciliation
            ? this.toFixedApp(
                element.conciliation.amount * element.conciliation.rate
              )
            : 0,
        },
      ];
    });
    return response;
  };

  toFixedApp = (x: any) => {
    let a: any = `e+${2}`;
    let b: any = `e-${2}`;
    return +(Math.round(x + a) + b);
  };

  findConciliationObject = (obj: any, reference: any) => {
    return obj.find((element: any) => element.paymentMethodId === reference);
  };

  getElements = (obj: any, type: any) => {
    let response: any = [];
    obj
      .filter((row: any) => row.TIPOREG !== '01')
      .map((row: any) => {
        if (row.TIPOREG === '02') response = [...response, row];
        if (row.TIPOREG === '03') {
          let position = response.findIndex((ele: any) => {
            return ele.REFDEB === row.REFDEB && !ele.ERROR;
          });
          if (position != -1) {
            console.log(response[position]['TOTCOB']);
            if(response[position]['TOTCOB']==="0.00"){
              response[position]['ERROR'] = row;
            }
          }
        }
      });
    return response;
  };

  // ══ Número de lote del banco ═══════════════════════════════════════════════
  // Bancos como Bancaribe exigen su propio número, que se teclea a mano al confirmar
  // la carga. Se carga mal a menudo y no había forma de corregirlo: el lote quedaba
  // con el número equivocado para siempre.

  /** El flag del banco es la señal buena; un número ya asignado también lo delata. */
  usaLoteManual = (): boolean => {
    return !!(this.bank?.direct_debit_manual_lote || this.current_direct_debit?.manual_lote);
  };

  /** Solo mientras el proceso siga vivo: un lote cerrado se concilió contra ese número. */
  puedeEditarLoteManual = (): boolean => {
    const dd = this.current_direct_debit;
    if (!dd || !this.usaLoteManual()) return false;
    if (dd.completed === true || dd.active === false) return false;
    return !['FINISHED', 'ABORTED'].includes(dd.status);
  };

  editarLoteManual = async () => {
    const dd = this.current_direct_debit;
    const esCorreccion = !!dd.manual_lote;

    const result = await Swal.fire({
      title: esCorreccion ? 'Corregir número de lote del banco' : 'Asignar número de lote del banco',
      html: `Lote interno: <b>${dd.lote}</b><br>Banco: <b>${this.bank?.name || '-'}</b>` +
            (esCorreccion ? `<br><br>Número actual: <b>${dd.manual_lote}</b>` : ''),
      input: 'text',
      inputValue: dd.manual_lote || '',
      inputAttributes: { autocapitalize: 'off' },
      inputPlaceholder: 'Número que asignó el banco',
      showCancelButton: true,
      confirmButtonText: 'Guardar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      inputValidator: (value) => (!value || !value.trim()) ? 'El número de lote es obligatorio' : null
    });

    if (!result.isConfirmed) return;
    const nuevo = String(result.value).trim();
    if (nuevo === (dd.manual_lote || '')) return;

    try {
      const r = await this.directDebitService.direct_debit_manual_lote({ id: dd._id, manual_lote: nuevo });
      if (r?.success) {
        Swal.fire({
          icon: 'success',
          title: esCorreccion ? 'Número corregido' : 'Número asignado',
          text: `El lote ${dd.lote} quedó con el número ${nuevo}.`,
          timer: 2200,
          showConfirmButton: false
        });
        await this.updateCurrentDirectDebit();
      } else {
        Swal.fire({ icon: 'error', title: 'No se pudo guardar', text: r?.msg || 'El servidor rechazó el cambio' });
      }
    } catch (e: any) {
      // El backend explica el motivo (banco sin lote manual, proceso ya cerrado…).
      Swal.fire({
        icon: 'error',
        title: 'No se pudo guardar',
        text: e?.error?.msg || e?.message || 'Error de comunicación con el servidor'
      });
    }
  };

  confirm_upload = async () => {
    let manual_lote;
    if(this.bank.direct_debit_manual_lote) {
      Swal.fire({
        title: "Ingrese el número de identificación del lote:",
        input: "text",
        inputAttributes: {
          autocapitalize: "off"
        },
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        showCancelButton: true,
        confirmButtonText: `Continuar!`,
        cancelButtonText: `Cancelar!`,
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading()
      }).then((result) => {
        if (result.isConfirmed) {
          if(result.value!=="") {
            this.process_confirm(result.value);
          } else {
            Swal.fire({
              icon: "warning",
              html: 'El número de lote es obligatorio.'
            });
          }
          
        }
      });
    } else {
      this.process_confirm(null);
    }
    
  };

  process_confirm = (lote: any) => {
    Swal.fire({
      title: 'Confirmación',
      text: 'Solo debe confirmar cuando el archivo se haya recibido de forma exitosa por el banco ¿Desea confirmar?',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      showCancelButton: true,
      confirmButtonText: `Si!`,
      cancelButtonText: `Cancelar!`,
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      if (result.isConfirmed) {
        this.loading_section['UPLOADED'] = true;
        let body_2 = {
          direct_debit_id: this.current_direct_debit._id,
          status: 'UPLOADED',
          user: this.sessionUser.uid,
          url: undefined,
        };
        await this.directDebitService.saveDirectDebitStatus(body_2);

        if(lote) {
          await this.directDebitService.direct_debit_manual_lote({
            id: this.current_direct_debit._id,
            manual_lote: lote
          });
        }
        
        this.loading_section['UPLOADED'] = false;
        await this.updateCurrentDirectDebit();
      }
    });
  }

  cancel_process = () => {
    Swal.fire({
      title: 'Alerta',
      text: '¿Desea cancelar el proceso, esta acción no se puede revertir, desea continuar?',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      showCancelButton: true,
      confirmButtonText: `Si!`,
      cancelButtonText: `Cancelar!`,
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      if (result.isConfirmed) {
        this.loading_section['UPLOADED'] = true;
        let body = {
          id: this.current_direct_debit._id,
          user: this.sessionUser.uid,
        };
        await this.directDebitService.cancel_direct_debit(body);
        this.loading_section['UPLOADED'] = false;
        await this.updateCurrentDirectDebit();
      }
    });
  };

  restart_process_conciliation = async() => {
    let body = {
      trace: "DIRECTDEBIT_GENERATE_CONCILIATION_"+this.current_direct_debit.trace
    };
    await this.directDebitService.cancel_direct_debit_trace(body);
    this.btn_restart_conciliation = false;
    this.response_trace_conciliation = null;
    // Igual que en resetTraceProcess: el trace cancelado ya no aplica, el monitor debe
    // volver a buscar en vez de seguir mostrando el estado del intento anterior.
    if (this.progressMonitorComponent) {
      await this.progressMonitorComponent.reload();
    }
    await this.updateCurrentDirectDebit();
  };

  restart_process = async() => {
    this.btn_restart = false;
    this.loading_section['UPLOADED'] = true;
    let body = {
      id: this.current_direct_debit._id,
      user: this.sessionUser.uid,
    };
    await this.directDebitService.cancel_direct_debit(body);
    this.loading_section['UPLOADED'] = false;
    await this.updateCurrentDirectDebit();
  };

  resetTraceProcess = async() => {
    // Mostrar modal de confirmación con input de contraseña
    const { value: password } = await Swal.fire({
      title: '⚠️ Reiniciar Proceso',
      html: `
        <div style="text-align: left; padding: 10px;">
          <p style="color: #d32f2f; font-weight: bold; margin-bottom: 15px;">
            <i class="fas fa-exclamation-triangle"></i> ADVERTENCIA: Esta es una acción delicada
          </p>
          <p style="margin-bottom: 15px;">
            Esta acción cambiará el estado del trace a <strong>false</strong>, 
            lo que permitirá reiniciar el proceso de conciliación.
          </p>
          <p style="margin-top: 20px; margin-bottom: 10px; font-weight: bold;">
            Para confirmar, ingrese la contraseña de seguridad:
          </p>
        </div>
      `,
      input: 'password',
      inputPlaceholder: 'Ingrese la contraseña',
      inputAttributes: {
        autocapitalize: 'off',
        autocorrect: 'off'
      },
      showCancelButton: true,
      confirmButtonText: 'Reiniciar Proceso',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#d32f2f',
      cancelButtonColor: '#757575',
      showLoaderOnConfirm: true,
      preConfirm: async (password) => {
        if (!password) {
          Swal.showValidationMessage('Debe ingresar la contraseña');
          return false;
        }
        
        // Validar contraseña hardcoded
        if (password !== 'estoysuperdeacuerdo') {
          Swal.showValidationMessage('Contraseña incorrecta');
          return false;
        }

        try {
          // Llamar al servicio para reiniciar el trace
          const traceType = `DIRECTDEBIT_GENERATE_CONCILIATION_${this.current_direct_debit.trace}`;
          const result = await this.directDebitService.resetTrace(traceType, password);
          return result;
        } catch (error: any) {
          Swal.showValidationMessage(
            `Error: ${error?.error?.message || 'No se pudo reiniciar el proceso'}`
          );
          return false;
        }
      },
      allowOutsideClick: () => !Swal.isLoading()
    });

    if (password) {
      // Mostrar mensaje de éxito
      await Swal.fire({
        icon: 'success',
        title: 'Proceso Reiniciado',
        html: `
          <p>El trace ha sido reiniciado exitosamente.</p>
          <p style="margin-top: 10px;">
            <small style="color: #666;">
              El status del trace ahora es <strong>false</strong> y puede reiniciar el proceso.
            </small>
          </p>
        `,
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#4caf50'
      });

      // Actualizar la vista y ocultar el botón
      this.btn_restart_conciliation = false;
      this.response_trace_conciliation = null;
      this.show_reset_trace_button = false;
      this.lastProgressPercentage = null;
      this.lastProgressChangeTime = null;
      
      // Limpiar intervalo si existe
      if (this.progressCheckInterval) {
        clearInterval(this.progressCheckInterval);
        this.progressCheckInterval = null;
      }
      
      // El trace anterior quedó inactivo: el monitor tiene que olvidarlo y volver a buscar,
      // si no sigue mostrando el estado del proceso reiniciado hasta recargar el navegador.
      if (this.progressMonitorComponent) {
        await this.progressMonitorComponent.reload();
      }

      await this.updateCurrentDirectDebit();
    }
  };


  getHeader = (obj: any, type: any) => {
    let response: any = [];
    if(type==="Mercantil" || type==="Bancaribe") {
      return obj.filter((row: any) => row.TIPOREG.toString() === '1');
    } else if(type==="Provincial") {
      return obj.filter((row: any) => row.TIPOREG.toString() === '6110');
    } else {
      return obj.filter((row: any) => row.TIPOREG === '01');
    }
  };

  formatElements = (elements: any) => {
    let response: any = [];
    let element: any;
    elements.map((ele: any) => {
      element = {
        res: ele.TIPOREG,
        success: ele.ERROR ? false : true,
        identity: ele.CEDULA,
        num_cuenta: ele.NROCTA1,
        reference: ele.REFDEB,
        amount: ele.TOTCOB,
        description: ele.DESCSTA,
        num_credit: ele.REFDEB.replace(/^0+/, '').slice(0, -1),
        error: ele.ERROR ? ele.ERROR : undefined,
      };
      response = [...response, element];
    });
    return response;
  };

  downloadFile = async (url:any, extension: string, name: string) => {
    // La extensión del parámetro es sólo respaldo: la real se deduce de la URL. Sin esto,
    // la respuesta de bancos que la envían en Excel (Bancaribe) se bajaba como .txt.
    const ext = this.directDebitService.extensionRealDeUrl(url) || extension;
    let res = await this.directDebitService.downloadImage(url, ext);
    this.downloadCheck();
    if(res) {
      saveAs(res, `${name}.${ext}`);
    }
  }

  finalizar = async() => {
    let body = {
      id: this.current_direct_debit._id
    };
    await this.directDebitService.finish_direct_debit(body);
    this.updateCurrentDirectDebit();
  }

  // Métodos para búsqueda de productos
  filterProducts() {
    if (!this.products) {
      this.filteredProducts = [];
      return;
    }

    if (!this.productSearchTerm || this.productSearchTerm.trim() === '') {
      // Si no hay término de búsqueda, mostrar todos los productos
      this.filteredProducts = [...this.products];
      return;
    }

    const term = this.productSearchTerm.toLowerCase().trim();
    this.filteredProducts = this.products.filter((product: any) => {
      return (
        product?.params?.name?.toLowerCase().includes(term) ||
        product?.params?.code?.toLowerCase().includes(term)
      );
    });
  }

  selectProduct(product: any) {
    // Mostrar el código del producto en lugar del nombre
    this.productSearchTerm = product?.params?.code || '';
    this.form.patchValue({
      product: product?.params?.code || ''
    });
    this.showProductDropdown = false;
    this.loadProductRateInfo(product?.params?.code);
    this.applyProductFilters().then(() => this.updateCurrentDirectDebit());
  }

  showProductOptions() {
    this.showProductDropdown = true;
    // Siempre mostrar todos los productos cuando se hace click en el buscador
    this.filteredProducts = [...this.products];
  }

  hideProductOptions() {
    // Delay to allow click events to register
    setTimeout(() => {
      this.showProductDropdown = false;
    }, 200);
  }

  clearProductSearch() {
    const currentProduct = this.form.get('product')?.value;
    
    // Si el producto actual es CREDIT, solo limpiar el texto pero mantener CREDIT seleccionado
    if (currentProduct === 'CREDIT') {
      this.productSearchTerm = '';
      // NO cambiar el valor del formulario, mantener CREDIT
      this.showProductDropdown = false;
      // NO llamar a updateCurrentDirectDebit() para evitar recargar
    } else {
      // Para otros productos, limpiar completamente
      this.productSearchTerm = '';
      this.form.patchValue({
        product: ''
      });
      this.showProductDropdown = false;
      this.updateCurrentDirectDebit();
    }
  }

  // Cargar información de la tasa del producto
  loadProductRateInfo = async (productType: string) => {
    if (!productType) {
      this.productRateInfo = null;
      return;
    }

    try {
      this.loadingRateInfo = true;
      this.rateInfoError = false;
      this.rateInfoErrorMessage = '';
      const response = await this.directDebitService.getProductRateInfo(productType);
      
      if (response && response.success) {
        this.productRateInfo = response.data;
        
        // Verificar si la tasa está disponible
        if (this.productRateInfo && !this.productRateInfo.rate_available) {
          this.rateInfoError = true;
          this.rateInfoErrorMessage = `La tasa "${this.productRateInfo.rate_name}" no está disponible. Por favor, configure la tasa antes de iniciar el proceso.`;
          console.warn('Tasa no disponible:', this.productRateInfo);
        } else {
          this.rateInfoError = false;
          console.log('Información de tasa:', this.productRateInfo);
        }
      } else {
        this.productRateInfo = null;
        this.rateInfoError = true;
        this.rateInfoErrorMessage = response?.msg || 'Error al obtener información de la tasa';
        console.error('Error en respuesta de tasa:', response);
      }
    } catch (error) {
      console.error('Error al obtener información de tasa:', error);
      this.productRateInfo = null;
      this.rateInfoError = true;
      this.rateInfoErrorMessage = 'Error al obtener información de la tasa';
    } finally {
      this.loadingRateInfo = false;
    }
  };

  ngOnDestroy() {
    if(this.changesDirectDebitSubscription) {
      this.changesDirectDebitSubscription.unsubscribe();
    }
    
    // Limpiar intervalo de progreso si existe
    if (this.progressCheckInterval) {
      clearInterval(this.progressCheckInterval);
      this.progressCheckInterval = null;
    }
  }

  
}
